import { IntegrationType } from '../api/graphql';

/** How the product names an integration to the user. */
export const integrationName = (type: IntegrationType): string => {
  switch (type) {
    case IntegrationType.AmsAppliedEpic:
      return 'Applied Epic';
    case IntegrationType.AmsHawksoft:
      return 'HawkSoft';
    case IntegrationType.AmsNowcerts:
      return 'NowCerts';
    case IntegrationType.AmsEzlynx:
      return 'EZLynx';
    case IntegrationType.Ams_360:
      return 'AMS360';
    case IntegrationType.CrmAgencyZoom:
      return 'AgencyZoom';
    case IntegrationType.CrmHubspot:
      return 'HubSpot';
    case IntegrationType.Zapier:
      return 'Zapier';
    case IntegrationType.AmsImageright:
      return 'ImageRight';
    case IntegrationType.AmsQqcatalyst:
      return 'QQCatalyst';
    case IntegrationType.Cara:
      return 'Cara';
    default: {
      // Exhaustive check: if a new IntegrationType is added, this will cause a TypeScript error
      const _exhaustiveCheck: never = type;
      return _exhaustiveCheck;
    }
  }
};
